<template>
  <div id="app">
    <!-- Alert and Loader -->
    <Loader v-if="loader" />
    <router-view />
  </div>
</template>

<script>
import { mapState } from "vuex";
// Components

import Loader from "@/components/Loader";
// Layouts
import ClientLayout from "@/layouts/ClientLayout";
import PublicLayout from "@/layouts/PublicLayout";

import firebaseInitialize from "./firebase";

export default {
  data() {
    return {};
  },
  components: {
    ClientLayout,
    PublicLayout,

    Loader,
  },
  computed: {
    ...mapState("session", ["token"]),
    ...mapState(["loader"]),
  },
  created() {
    firebaseInitialize();
  },
};
</script>
